import TransactionLayout from "features/transactions/TransactionsLayout";
import { RouteObject } from "react-router-dom";

export const transactionRoutes: RouteObject = {
  id: "transactions",
  path: "transactions",
  element: <TransactionLayout />,
  children: [
    {
      id: "transactionsTableDraft",
      index: true,
      lazy: async () => {
        const { TransactionDraftPage } = await import(
          "features/transactions/TransactionDraftPage"
        );
        return { Component: TransactionDraftPage };
      },
      handle: {
        description: "Transactions Table",
      },
    },
    {
      id: "transactionsTableDetails",
      path: ":viewId/details",

      lazy: async () => {
        const { TransactionsViewDetailPage } = await import(
          "features/transactions/TransactionViewDetailPage"
        );
        return { Component: TransactionsViewDetailPage };
      },
    },
  ],
};
